import qrcode from 'qrcode-generator'

/**
 * QR-код ссылки талона как один SVG-путь: рисуем сами через `react-native-svg`, который в
 * проекте уже есть, вместо отдельной RN-библиотеки с двумя десятками зависимостей.
 *
 * Уровень коррекции — `L`: талон занимает 800+ символов, и при `M` модули становятся такими
 * мелкими, что сканер приложения не берёт код с экрана (проверено вживую 20.10.2026).
 */
export interface QrPath {
  /** Размер в модулях (без полей). */
  size: number
  /** Путь в координатах модулей: 1 единица = 1 модуль. */
  path: string
}

export function qrPath(text: string): QrPath {
  const qr = qrcode(0, 'L')
  qr.addData(text)
  qr.make()

  const size = qr.getModuleCount()
  const parts: string[] = []

  for (let row = 0; row < size; row += 1) {
    for (let col = 0; col < size; col += 1) {
      if (qr.isDark(row, col)) parts.push(`M${col} ${row}h1v1h-1z`)
    }
  }

  return { size, path: parts.join('') }
}
